import React, { useState } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const handleForgotPassword = async (values) => {
    setMessage('');
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: values.email }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage(data.message);
      } else {
        setError(data.message || 'Something went wrong');
      }
    } catch (err) {
      setError('Server error, please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: '100px auto',
        padding: 24,
        background: '#fff',
        borderRadius: 12,
        textAlign: 'center',
      }}
    >
      <h2 style={{ marginBottom: 16 }}>Forgot Password</h2>

      <Form layout="vertical" onFinish={handleForgotPassword}>
        <Form.Item
          label="Email Address"
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Invalid email' },
          ]}
        >
          <Input placeholder="Enter your registered email" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Send Temporary Password
          </Button>
        </Form.Item>
      </Form>

      {message && (
        <Alert
          message={message}
          type="success"
          showIcon
          style={{ marginTop: 16 }}
        />
      )}
      {error && (
        <Alert
          message={error}
          type="error"
          showIcon
          style={{ marginTop: 16 }}
        />
      )}

      {/* Back to login link */}
      <div style={{ marginTop: 24 }}>
        <Button
          type="link"
          onClick={() => navigate('/signin')}
          style={{ fontSize: 14 }}
        >
          ← Back to Login
        </Button>
      </div>
    </div>
  );
}

export default ForgotPassword;
